export var PartitionFormat;
(function (PartitionFormat) {
    PartitionFormat["PARTITION_FORMAT_HIVE"] = "HIVE";
    PartitionFormat["PARTITION_FORMAT_DIRECT"] = "DIRECT";
})(PartitionFormat || (PartitionFormat = {}));
